/**
 * Тип поля
 */
export var FieldType;

(function (FieldType) {
  FieldType["Hidden"] = "hidden";
  FieldType["Text"] = "text";
  FieldType["Email"] = "email";
  FieldType["Password"] = "password";
  FieldType["Number"] = "number";
  FieldType["Search"] = "search";
  FieldType["Textarea"] = "textarea";
  FieldType["Checkbox"] = "checkbox";
  FieldType["Radio"] = "radio";
  FieldType["CheckboxGroup"] = "checkbox_group";
  FieldType["RadioGroup"] = "radio_group";
  FieldType["Select"] = "select";
  FieldType["MultiSelect"] = "multi_select";
  FieldType["Date"] = "date";
  FieldType["Time"] = "time";
  FieldType["DateTime"] = "date_time";
  FieldType["DateRange"] = "date_range";
  FieldType["Switch"] = "switch";
  FieldType["SwitchGroup"] = "switch_group";
  FieldType["Find"] = "find";
  FieldType["Autocomplete"] = "autocomplete";
  FieldType["MultiAutocomplete"] = "multi_autocomplete";
  FieldType["AsyncAutocomplete"] = "async_autocomplete";
  FieldType["AsyncMultiAutocomplete"] = "async_multi_autocomplete";
  FieldType["File"] = "file";
})(FieldType || (FieldType = {}));